module.exports = __webpack_public_path__ + "img/grey-webinars-3.1a99dd1d.png";